const _ = require('underscore');

// this function assumes searchTokens entries are already lowercased, so we
// don't have to repeat that work with every call.

function selectMatchingLocation (searchTokens, locations) {
    const defaultChoice = null;

    if (!searchTokens || searchTokens.length === 0) {
        return defaultChoice;
    }

    const bestChoice = _.chain(locations)
        .map((location) => {
            const { city, region, country, countryCode } = location;
            const locationTokens = _.chain([city, region, country, countryCode])
                .map((s) => s.toLowerCase().split(/\s+/g))
                .flatten()
                .value();
            const locationTokenString = locationTokens.join(' ');
            let score = 1;

            _.each(searchTokens, (token) => {
                // lazy match is worth some
                if (locationTokenString.indexOf(token) >= 0) {
                    score += 1;
                }
                // exact token match is worth more
                if (locationTokens.indexOf(token) >= 0) {
                    score += 5;
                }
            });

            return {location, score};
        })
        .reduce((memo, next) => (next.score > memo.score) ? next : memo)
        .value();

    // if we don't get any matches, don't return a best match
    if (bestChoice.score > 1) {
        return bestChoice.location;
    }

    return defaultChoice;
}

module.exports = {
    selectMatchingLocation
};



// WEBPACK FOOTER //
// ./app/lib/MentorTimeTrackerUtils.js